import type { HelpArticleDef } from "./articleKit";
import { GETTING_STARTED_ARTICLES } from "./articlesGettingStarted";
import { SELLING_ARTICLES } from "./articlesSelling";
import { MARKETING_ARTICLES } from "./articlesMarketing";
import { INSIGHT_ARTICLES } from "./articlesInsight";
import { ADMIN_ARTICLES } from "./articlesAdmin";

/** The whole knowledge base, in display order. */
export const HELP_ARTICLES: HelpArticleDef[] = [
  ...GETTING_STARTED_ARTICLES,
  ...SELLING_ARTICLES,
  ...MARKETING_ARTICLES,
  ...INSIGHT_ARTICLES,
  ...ADMIN_ARTICLES,
];

export const helpArticle = (slug: string): HelpArticleDef | undefined =>
  HELP_ARTICLES.find((a) => a.slug === slug);

/**
 * App route → the article that explains that screen. Drives the "Read the
 * full guide" link in the header help popover.
 */
export const ROUTE_ARTICLE: Record<string, string> = {
  "/": "getting-started",
  "/contacts": "contacts-and-companies",
  "/companies": "contacts-and-companies",
  "/deals": "deals-and-pipeline",
  "/tasks": "tasks-and-calendar",
  "/inbox": "inbox-and-email-capture",
  "/reports": "reports-and-attribution",
  "/sales": "settings-and-administration",
  "/settings/profile": "settings-and-administration",
  "/settings/account-defaults": "settings-and-administration",
  "/settings/billing": "settings-and-administration",
  "/settings/objects": "settings-and-administration",
  "/settings/lifecycle": "contacts-and-companies",
  "/settings/custom-fields": "settings-and-administration",
  "/marketing": "forms",
  "/marketing/emails": "email-templates-and-campaigns",
  "/marketing/lists": "lists-and-segments",
  "/marketing/sequences": "sequences",
  "/marketing/workflows": "workflows-and-lead-scoring",
  "/marketing/campaigns": "email-templates-and-campaigns",
  "/reports/library": "reports-and-attribution",
  "/reports/scorecard": "reports-and-attribution",
  "/reports/attribution": "reports-and-attribution",
  "/reports/web": "reports-and-attribution",
  "/reports/builder": "dashboards-and-report-builder",
  "/settings/signals": "keep-an-eye-on",
  "/settings/integrations": "integrations",
  "/settings/import-export": "importing-your-data",
};
